import { ContentLayout, Header } from "@amzn/awsui-components-react";
import { FC } from "react";
import Layout from "../../../layout/Layout";

const ManageFonts: FC<any> = () => {
    return (
        <Layout>
            <ContentLayout header={<Header variant="h1">Fonts</Header>}>
                <>Fonts</>
            </ContentLayout>
        </Layout>
    )
}
export default ManageFonts;